import { ErrorLogComponent } from '@cian/error-log-component';
import * as React from 'react';
import { Provider } from 'react-redux';

import styles from './App.css';
import {
  FixedComponentsContext,
  FixedComponentsStore,
} from './components/common/fixed_component/fixed_components_store';
import { MobileVillageCardPage } from './components/mobile/mobile_village_card_page';
import { VillageCardPageContainer } from './components/village_card/container';
import { TReduxStore } from './store';
import { IApplicationContext } from './types/applicationContext';
import { ApplicationContext } from './utils/applicationContext';

export interface IAppProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
}

export class App extends React.Component<IAppProps> {
  private fixedComponentsStore = new FixedComponentsStore();

  public render() {
    const { reduxStore, context } = this.props;
    const {
      mobile: { isMobileVersion },
    } = reduxStore.getState();

    return (
      <ErrorLogComponent logger={context.logger}>
        <ApplicationContext.Provider value={context}>
          <FixedComponentsContext.Provider value={this.fixedComponentsStore}>
            <div className={styles['index']}>
              <Provider store={reduxStore}>
                {isMobileVersion ? <MobileVillageCardPage /> : <VillageCardPageContainer />}
              </Provider>
            </div>
          </FixedComponentsContext.Provider>
        </ApplicationContext.Provider>
      </ErrorLogComponent>
    );
  }
}
